import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import {WaaValue} from "./models/widget-app-assessment-v0-args.dto";
import {of} from "rxjs";
import { WidgetDialogService } from '../../../services/widget-dialog.service';

@Component({
  selector: 'pt-waa-edit-row-col4',
  template: `
    <div class='form-group mb-0 pt-waa-edit-row-col4'
         *ngIf="viewMode === 'TEXTAREA'">
<!--      <label class="form-label">{{ headerNode }}</label>-->
      <textarea
        autocomplete='off'
        [disabled]="disabled"
        (focusout)="changeNote.emit(currentNote);"
        [(ngModel)]="currentNote"
        class='form-control form-control-sm'
        [rows]='5'>
      </textarea>
    </div>

    <div class="widget-btn-link"
         *ngIf="viewMode === 'DIALOG'"
         (click)='openTextArea(headerNode, currentNote)'>
      {{ headerNode }}
    </div>
  `,
  styles: [`
    .widget-btn-link {
      width: 100%;
      color: #0D6EFDFF;
      text-decoration: underline;
      /*text-align: center;*/
    }

    .widget-btn-link:hover {
      color: #0a58ca;
      cursor: pointer;
    }

    .pt-waa-edit-row-col4 .form-control:disabled, .form-control[readonly] {
      background: white !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class WaaEditRowCol4Component implements OnChanges {
  @Input() viewMode: 'TEXTAREA' | 'DIALOG' = 'TEXTAREA';
  @Input() uuid: string;
  @Input() disabled: boolean;
  @Input() value: WaaValue[];
  @Input() headerNode?: string;
  @Output() changeNote = new EventEmitter<string>();
  public currentNote?: string;

  constructor(private widgetDialogService: WidgetDialogService) {
  }

  ngOnChanges(): void {
    if (this.value && this.uuid) {
      this.currentNote = this.value.find(v => v.uuid === this.uuid)?.note || '';
    }
  }

  openTextArea(title?: string, note?: string) {
    const dialog = this.widgetDialogService.runTextArea(of(title), note, !this.disabled);
    dialog.subscribe((value?: string) => {
      if (value !== this.currentNote && !this.disabled) {
        this.currentNote = value;
        this.changeNote.emit(value);
      }
    });
  }
}
